/// <amd-module name="VSS/Redux/Modules/ContentViewObserver/ContentViewObserverReducer" />
import { default as produce } from "immer";
import { IContentViewObserverState } from "./ContentViewObserverContracts";
import { ContentViewObserverActions, ContentViewObserverActionTypes } from "./ContentViewObserverActions";

export function filterObserverReducer(state: IContentViewObserverState, action: ContentViewObserverActions): IContentViewObserverState {
    state = state || getDefaultState();
    return produce(state, draft => {
        switch (action.type) {
            case ContentViewObserverActionTypes.InitializeSelectedPivot: {
                const { selectedPivot } = action.payload;
                draft.selectedPivot = selectedPivot;
                break;
            }
            case ContentViewObserverActionTypes.InitializeFilterState: {
                const { filterDetails } = action.payload;
                draft.filterDetails = filterDetails;
                break;
            }
            case ContentViewObserverActionTypes.FilterStateChanged: {
                if (!draft.filterDetails) {
                    throw Error("Filter is not initialized");
                }
                draft.filterDetails.filterState = { ...draft.filterDetails.filterState, ...action.payload };
                break;
            }
            case ContentViewObserverActionTypes.SelectedPivotChanged: {
                draft.selectedPivot = action.payload;
                break;
            }
            case ContentViewObserverActionTypes.FilterToggled: {
                if (!draft.filterDetails) {
                    throw Error("Filter is not initialized");
                }
                draft.filterDetails.filterVisible = action.payload;
            }
        }
    });
}

function getDefaultState(): IContentViewObserverState {
    return {
        selectedPivot: ""
    };
}
